import type { ChakraProps } from '@/ui';

export const textStyles: Record<string, ChakraProps> = {
  // ALL-CAPS section labels (e.g. sidebar section headers)
  ahLabel: {
    fontSize: 'ah-label',
    fontWeight: 700,
    letterSpacing: 'ah-label',
    textTransform: 'uppercase',
    color: 'ink.soft',
  },
  ahRow: {
    fontSize: 'ah-row',
    fontWeight: 500,
    color: 'ink.strong',
  },
  // Muted status/meta text (e.g. "Edited 2m ago")
  ahStatus: {
    fontSize: 'ah-status',
    color: 'ink.muted',
  },
  // Control labels — breadcrumbs, tab labels, input titles
  ahControl: {
    fontSize: 'ah-control',
    fontWeight: 700,
    color: 'ink.strong',
  },
  magic: {
    bgClip: 'text',
    bgGradient: 'linear-gradient(to right, #685EDB, #D5257C)',
  },
  secondary: {
    fontSize: '14px',
    color: 'customgray.mid',
  },
};
